import { PageSize } from '@/constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IContractedKoreanBusinessDetailStore,
	IForeignDashboardStatisticStore,
	IPayloadGetContractedKoreanBusinessListRequest,
	IPayloadGetContractedKoreanBusinessListSuccess,
	IPayloadGetForeignDashboardStatisticRequest,
	IPayloadGetForeignDashboardStatisticSuccess,
} from './foreign-dashboard.type';

const initialState = {
	foreignDashboardStatistic: {
		fetching: false,
		data: [] as IForeignDashboardStatisticStore,
	},
	contractedKoreanBusiness: {
		fetching: false,
		data: [] as IContractedKoreanBusinessDetailStore[],
		total: 0,
		params: {
			page: 1,
			pageSize: PageSize.S,
		},
	},
};

const foreignDashboardSlice = createSlice({
	initialState,
	name: 'foreignDashboard',
	reducers: {
		/**---- GET WORKER DASHBOARD LIST START ---- */
		getForeignDashboardStatisticRequest: (
			state,
			action: PayloadAction<IPayloadGetForeignDashboardStatisticRequest>
		) => {
			state.foreignDashboardStatistic.fetching = true;
		},
		getForeignDashboardStatisticSuccess: (
			state,
			action: PayloadAction<IPayloadGetForeignDashboardStatisticSuccess>
		) => {
			const { foreignDashboardStatistic } = action.payload;
			state.foreignDashboardStatistic.data = foreignDashboardStatistic;
			state.foreignDashboardStatistic.fetching = false;
		},
		getForeignDashboardStatisticFailure: (state) => {
			state.foreignDashboardStatistic.fetching = false;
		},
		/**---- GET WORKER DASHBOARD LIST END ---- */

		/**---- GET CONTRACTED KOREAN BUSINESS LIST START ---- */
		getContractedKoreanBusinessListRequest: (
			state,
			action: PayloadAction<IPayloadGetContractedKoreanBusinessListRequest>
		) => {
			const { page, pageSize } = action.payload;
			state.contractedKoreanBusiness.fetching = true;
			state.contractedKoreanBusiness.params = { page, pageSize };
		},
		getContractedKoreanBusinessListSuccess: (
			state,
			action: PayloadAction<IPayloadGetContractedKoreanBusinessListSuccess>
		) => {
			const { content, total } = action.payload;
			state.contractedKoreanBusiness.data = content;
			state.contractedKoreanBusiness.fetching = false;
			state.contractedKoreanBusiness.total = total;
		},
		getContractedKoreanBusinessListFailure: (state) => {
			state.contractedKoreanBusiness.fetching = false;
		},
		/**---- GET CONTRACTED KOREAN BUSINESS LIST END ---- */
	},
});

export const ForeignDashboardSelectors = {
	selectStatisticFetching: (state: RootState) =>
		state.foreignDashboard.foreignDashboardStatistic.fetching,
	selectWorkerDashboardStatistic: (state: RootState) =>
		state.foreignDashboard.foreignDashboardStatistic.data,
	selectContractedKoreanBusinessFetching: (state: RootState) =>
		state.foreignDashboard.contractedKoreanBusiness.fetching,
	selectContractedKoreanBusiness: (state: RootState) =>
		state.foreignDashboard.contractedKoreanBusiness.data,
	selectContractedKoreanBusinessTotal: (state: RootState) =>
		state.foreignDashboard.contractedKoreanBusiness.total,
	selectContractedKoreanBusinessParams: (state: RootState) =>
		state.foreignDashboard.contractedKoreanBusiness.params,
};

export const ForeignDashboardActions = foreignDashboardSlice.actions;
export const ForeignDashboardReducer = foreignDashboardSlice.reducer;
